
export async function loadLocalFile(url) {
  return new Promise((resolve, reject) => {
      document.addEventListener("deviceready", async () => {
          if (device.platform.toLowerCase() === "android") {
              url = "cdvfile://localhost/assets/www/" + url;
            } else if (device.platform.toLowerCase() === "ios") {
              url = "cdvfile://localhost/bundle/www/" + url;
            }
          resolveLocalFileSystemURL(
              url,
              function (entry) {
                  entry.file(
                      function (file) {
                          var reader = new FileReader();

                          reader.onloadend = function () {
                              // console.log('csv load result:')
                              // console.log(this.result)
                              resolve(this.result)
                          };

                          reader.readAsText(file);
                      },
                      function (err) {
                          console.error(err);
                          reject(err)
                      }
                  );
              },
              function (err) {
                  console.error(err);
                  reject(err)
              }
          );
      });
  });
}